import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import AuthContext from "context/AuthContext";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";

const Field = ({ label, value }) => (
  <div className="sm:py-4 sm:px-2 py-6 px-4">
    <strong>{label}</strong>
    <h6 className="mt-1 break-words">{value || "-"}</h6>
  </div>
);

const PartnerInquiryView = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { updatePageName, logoutUser } = useContext(AuthContext);
  const [inquiry, setInquiry] = useState(null);

  useEffect(() => {
    updatePageName(t("VIEW_PARTNER_INQUIRY"));
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await apiGet(`${apiPath.getPartnerInquiries}/${id}`);
        if (result?.data?.success) {
          setInquiry(result.data.results);
        }
      } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 409) {
          logoutUser();
        }
      }
    };
    if (id) load();
  }, [id]);

  return (
    <div>
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <div className="px-6 pt-6">
              <h2 className="text-lg font-semibold text-gray-800">{t("VIEW_PARTNER_INQUIRY")}</h2>
            </div>
            <div className="relative p-6 grid md:grid-cols-2">
              <Field label="Name" value={inquiry?.name} />
              <Field label="Title" value={inquiry?.title} />
              <Field label="Organization" value={inquiry?.organization} />
              <Field label="Work email" value={inquiry?.email} />
              <Field label="Phone" value={inquiry?.phone} />
              <Field label="Website" value={inquiry?.website} />
              <Field label="Partnership type" value={inquiry?.partnershipTypes?.join(", ")} />
              <Field label="Status" value={inquiry?.status === "viewed" ? "Viewed" : "New"} />
              <Field
                label="Submitted"
                value={inquiry?.createdAt ? dayjs(inquiry.createdAt).format("MM-DD-YYYY hh:mm A") : ""}
              />
              <div className="sm:py-4 sm:px-2 py-6 px-4 md:col-span-2">
                <strong>Partnership opportunity</strong>
                <h6 className="mt-1 whitespace-pre-wrap break-words">{inquiry?.opportunity || "-"}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
        <button
          className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6 ease-linear transition-all duration-150"
          type="button"
          onClick={() => navigate("/static-page-management/partner-inquiries")}
        >
          {t("O_BACK")}
        </button>
      </div>
    </div>
  );
};

export default PartnerInquiryView;
